// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"814":"a5a422ec","2141":"a5a422ec","4258":"a5a422ec","4921":"a5a422ec","5282":"a5a422ec","8433":"a5a422ec","8711":"a5a422ec"}[chunkId] + ".chunk.css";
};